import { useCameraRouteParams } from "@src/hooks/useCameraRouteParams";
import { LivestreamContent, JpegStreamContent } from "@src/features/cameras/components";
import { useTenantId } from "@src/features/tenants";

export default function LivestreamScreen() {
  const { isLegacyAppCamera, siteId, cameraKey } = useCameraRouteParams({
    requireSiteId: false,
    requireCameraKey: true,
  });
  const tenantId = useTenantId();

  if (isLegacyAppCamera) {
    return <JpegStreamContent />;
  }

  // Remount on a camera/tenant change so the frozen livestream URL is re-adopted
  // for the new camera instead of lingering on the previous feed.
  return <LivestreamContent key={`${tenantId}:${siteId}:${cameraKey}`} />;
}
